import { helpers } from 'vuelidate/lib/validators'

export const mobile = helpers.regex('mobile', /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7}|((\\+31|0|0031)6)[-]{1}[1-9]{1}[0-9]{7})$/);
export const landline = helpers.regex('landline', /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/);
export const postalcode =  helpers.regex('postalcode', /^[1-9][0-9]{3} ?[A-Z]{2}$/);  
export const address = helpers.regex('address', /^([1-9][e][\s])*([a-zA-Z]+(([.][\s])|([\s]))?)+[1-9][0-9]*(([-][1-9][0-9]*)|([\s]?[a-zA-Z]+))?$/); 

export const arrayIsNotNull = (value) => {
    if(!!value)
    {
        if(value.length > 0)
            return true;
    }
    return false;
}

export const fileValidation = (value) => 
{
    if(value != null)
    {
        const ext = value.name.split(".")[value.name.split(".").length - 1];
        const extentions = ['doc', 'docx', 'pdf', 'jpg', 'png', 'jpeg'];
        return value.size <= 4000000 && extentions.indexOf(ext.toLowerCase()) >= 0;
    }
    return true;
}
export const minFileSize = (value) => {
    if(value != null)
    {
        return value.size > 3;
    }
    return true;
}
export const validPermit = (value, vm) => {
    if(!vm.isSecurityCompany)
        return true;
        
    if(!!value) 
    {
        if(value.startsWith("ND"))
        {
            value = value.replace("-", "").trim();
            let no = value.split("ND")[value.split("ND").length - 1].trim();
            if(no.length == 4)
            {
                no = Number.parseInt(no);
                if(Number.isInteger(no))
                {
                    vm.permitNumber = "ND " + no;
                    return true;
                }
            }
        }
    }
    return false;
}
export const isDate = (value, vm) => {
    if(!!value)
    {
        if(typeof(value) == "string")
        {
            value = new Date(value);
        };

        if(value instanceof Date)
        {
            if(value < new Date(0,1,0) || value > new Date(new Date().setFullYear(new Date().getFullYear() - 17)))
                return false;

            return true;
        };
    }
    return false;
}

export const isDateGreaterThanToday = (value, vm) => {
    if(!!value)
    {
        if(typeof(value) == "string")
        {
            value = new Date(value);
        };

        if(value instanceof Date)
        {
            let date = new Date();
            if(value >= new Date(date.getFullYear(), date.getMonth(), date.getDate()))
                return true;
            return false;
        };
    }
    return false;
}

export const passNumber = (value) => {
    if(!!value) 
    {
        return !isNaN(value) && value.length == 11 && value.startsWith(201);
    };
    return false;
}